import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

   export const getDriverList = createAsyncThunk('appCalendar/getDriverList', async (CompanyID) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Driver/GetDriverList', CompanyID, {mode:'cors'})
    return response
  })

  export const addDriverEvent = createAsyncThunk('appCalendar/addDriverEvent', async (AddEvent) => {
    const response = await axios.post(' https://api.zasway.com:8443/Dashboard/AddEvent', AddEvent, {mode:'cors'})
    return response
  })

  export const getDriverEventsList = createAsyncThunk('appCalendar/getDriverEventsList', async (DriverEvents) => {
      //Anam Test Push Code
    const response = await axios.post(' https://api.zasway.com:8443/Dashboard/GetDriverEventsList', DriverEvents, {mode:'cors'})
    return response
  })

  export const editDriverEvent = createAsyncThunk('appCalendar/editDriverEvent', async (UpdateEvent) => {
    const response = await axios.post(' https://api.zasway.com:8443/Dashboard/UpdateEvent', UpdateEvent, {mode:'cors'})
    return response
  })

  export const deleteDriverEvent = createAsyncThunk('appCalendar/deleteDriverEvent', async (id) => {
    const response = await axios.post(' https://api.zasway.com:8443/DashBoard/DeleteEvent', id, {mode:'cors'})
    return response
  })

  export const getAllEvents = createAsyncThunk('appCalendar/getAllEvents', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/Dashboard/GetDriverEventsList', params, {mode:'cors'})
    return response.data
  })

  export const getCalendarEditData = createAsyncThunk('appCalendar/getCalendarEditData', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/Dashboard/GetDriverEventsList', params, {mode:'cors'})
    return {
      data: response.data
    }
  })

export const appCalendarSlice = createSlice({
  name: 'appCalendar',
  initialState: {
    events: [],
    selectedEvent: {},
    driverEventsEditData: []
  },
  reducers: {
    selectEvent: (state, action) => {
      state.selectedEvent = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getAllEvents.fulfilled, (state, action) => {
        state.events = action.payload
      })

      .addCase(getCalendarEditData.fulfilled, (state, action) => {
        state.driverEventsEditData = action.payload.data
      })
  }
})

export const { selectEvent } = appCalendarSlice.actions

export default appCalendarSlice.reducer
